
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 26 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.492 16.57c-3.244-3.12-3.245-8.176-.005-11.292 3.24-3.117 8.495-3.116 11.74.004 3.243 3.12 3.244 8.177.004 11.293-3.24 3.117-8.496 3.116-11.74-.005zM3.324 3.198C-1.11 7.464-1.107 14.382 3.33 18.65c3.898 3.749 9.921 4.207 14.334 1.372l5.607 5.393a1.572 1.572 0 002.162 0 1.431 1.431 0 000-2.08l-5.473-5.265c3.86-4.292 3.669-10.79-.57-14.867-4.437-4.268-11.63-4.272-16.065-.005z","fill":"#0D69D5"}})])
          )
        }
      }
    